import React, { Component } from "react";
import { modalhandler } from "../actions/modal-handler";
import { bindActionCreators } from "redux";
import { app } from "../index";

import { connect } from "react-redux";

import TNMPDF from "../components/pdf/tnmpdf";

class TMlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tnms: []
    };
  }
  gettnms(tmpayload) {
    app
      .service("tmsheets")
      .find({
        query: {
          id: {
            $in: tmpayload
          }
        }
      })
      .then(response =>
        this.setState({
          tnms: response.data ? response.data : response
        })
      );
  }
  gentnms() {
    if (
      this.state.tnms &&
      this.state.tnms.length &&
      this.props.wods.length &&
      this.props.customers
    ) {
      return this.state.tnms.map(tnm => {
        tnm.amount = tnm.calc_amount;
        let wodinfo = this.props.wods.find(
          wod => wod.workOrderNbr === tnm.workordernumber
        );
        let custinfo = this.props.customers.find(
          cust => cust.custnumber === tnm.custnumber
        );
        console.log("TNM", tnm, "WODInfo", wodinfo, "CustInfo", custinfo)
        return <TNMPDF tnm={tnm} wodinfo={wodinfo} custinfo={custinfo} />;
      });
    }
  }
  render() {
    var tmpayload = [];
    if (this.props.params.tmid) {
      tmpayload = tmpayload.concat(this.props.params.tmid);
    } else if (this.props.location.state.tnms) {
      tmpayload = this.props.location.state.tnmids;
    }
    if (tmpayload) {
      if (!this.state.tnms.length) {
        console.log("tmpayload", tmpayload, this.state.tnms);
        this.gettnms(tmpayload);
      }
      return <div className="TMlist Book"> {this.gentnms()} </div>;
    } else {
      return <h3> No Tnms found. </h3>;
    }
  }
}

function mapStateToProps(state) {
  return {
    employees: state.employees.employees,
    wods: state.workorders.derivitives,
    customers: state.custinfo.customers
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      modalhandler: modalhandler
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(TMlist);



// WEBPACK FOOTER //
// ./src/containers/TMlist.js